import ApiService from '@/services/ApiService'

/**
 * SocialiteService Class.
 *
 * @class
 */
export default class SocialiteService {
    /**
     * ApiService instance.
     *
     * @var {ApiService}
     */
    apiService

    /**
     * SocialiteService constructor.
     *
     * @returns {void}
     */
    constructor() {
        this.apiService = new ApiService(process.env.VUE_APP_AUTH_API)
    }

    /**
     * Get all available socialite providers.
     *
     * @param {Object} settings
     * @param {Object} device
     * @param {String} provider
     *
     * @returns {Promise}
     */
    getAvailableProviders({ api_key, company_uuid, cc, lang }) {
        return this.apiService
            .setApiKey(api_key)
            .setAcceptLanguage(`${lang}-${cc}`)
            .get(`/${company_uuid}/sso/`)
    }

    /**
     * Request Socialite Provider Redirect Url.
     *
     * @param {Object} settings
     * @param {Object} device
     * @param {String} provider
     *
     * @returns {Promise}
     */
    requestRedirectUrl({ api_key, company_uuid, cc, lang }, device, provider) {
        return this.apiService
            .setApiKey(api_key)
            .setAcceptLanguage(`${lang}-${cc}`)
            .post(`/${company_uuid}/sso/${provider}`, {
                device_type: device.type,
                device_identifier: device.identifier,
                device_name: device.name,
            })
    }

    /**
     * Check the status of the user code.
     *
     * @param {Object} settings
     * @param {String} verificationUri
     *
     * @returns {Promise}
     */
    status({ api_key }, verificationUri) {
        return this.apiService
            .setApiKey(api_key)
            .get(verificationUri)
    }
}
